import { PersonalInfosChangeData } from '../../../interfaces/PersonalInfosChangeData';
import { PersonalInfosChangeDataDto } from '../../../interfaces/dtos/PersonalInfosChangeDataDto';
import { ContractChangeMessageDto } from '../../../interfaces/dtos/ContractChangeMessageDto';
import { ContractChangeMessage } from '../../../interfaces/ContractChangeMessage';

export default function transformFormResponse(data: PersonalInfosChangeDataDto): PersonalInfosChangeData {
  const transformContract = (message: ContractChangeMessageDto): ContractChangeMessage => ({
    description: message.description,
    adjustedNumber: message.adjustedNumber,
    additionalInformations: message.additionalInformations,
  });
  return {
    changedContracts: data?.changedContracts?.map(transformContract),
    unchangedContracts: data?.unchangedContracts?.map(transformContract),
  };
}
